import { createClient, HttpError } from "@/http/lib";
import { apiBaseUrl } from "../config";

export const userPreference = createClient({
  baseURL: apiBaseUrl,
});

userPreference.interceptors.request.use(
  (config) => {
    const app = userPreference.getVueInstance();
    const store = app.config.globalProperties.$store;
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = store.getters["user/token"];
    return config.headers.Authorization ? config : Promise.reject(config);
  },
  (error) => Promise.reject(new HttpError(error))
);

userPreference.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(new HttpError(error));
  }
);
